//sort data bisa 1, 2, atau 3, parameter
const envApiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').trim();
const runtimeApiBaseUrl = (() => {
  if (envApiBaseUrl) return envApiBaseUrl;
  if (typeof window === 'undefined') return '';

  const hostname = String(window.location.hostname || '').trim().toLowerCase();

  // Local dev murni: frontend :3000 boleh langsung ke backend lokal :5000.
  if (window.location.port === '3000') {
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${window.location.protocol}//${window.location.hostname}:5000`;
    }

    // Dev publik: tetap lewat origin host agar backend bisa diproxy Nginx
    // dan port Node tidak perlu diekspos langsung ke internet.
    return `${window.location.protocol}//${window.location.hostname}`;
  }

  // Untuk production di Nginx, biarkan same-origin (/api/...).
  return '';
})();

export const backendPort = runtimeApiBaseUrl;

export function sortData(data, p1, o1 = 'ASC', p2, o2 = 'ASC', p3, o3 = 'ASC') {
  return [...data].sort((a, b) =>
    [[p1, o1], [p2, o2], [p3, o3]].reduce((r, [key, order]) => {
      if (r || !key) return r;
      const dir = order === 'DSC' ? -1 : 1;
      return a[key] > b[key] ? dir : a[key] < b[key] ? -dir : 0;
    }, 0)
  );
}
 
